import { useQuery } from '@tanstack/react-query'
import { fetchNationsByWorld } from '@/services/nations'

export function useNationsByWorld(worldId: string | undefined) {
  const nationsQuery = useQuery({
    queryKey: ['nations', 'world', worldId],
    queryFn: () => fetchNationsByWorld(worldId!),
    enabled: !!worldId,
  })

  return {
    nations: nationsQuery.data,
    isLoading: nationsQuery.isLoading,
    error: nationsQuery.error,
  }
}
